/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import { Event } from 'fierry/flux';

import Rpc from 'galax/rpc';
import Auth from 'shared/client/auth';


const getLocationString = () =>
{
  let searchQuery = [];

  const searchParams = new URLSearchParams(window.location.search);

  if (searchParams.has('fbclid'))
  {
    searchQuery.push('facebook');
  }

  if (searchParams.has('desktop'))
  {
    searchQuery.push('desktop');
  }

  if (searchParams.has('mobile'))
  {
    searchQuery.push('mobile');
  }

  if (searchQuery.length)
  {
    searchQuery = ' ' + searchQuery.join(', ')
  }

  return window.location.pathname + window.location.hash.substr(1) + searchQuery;
}


export default new Event ([ Auth, Rpc ], (auth, rpc) =>
{
  if(!auth.isLoggedOut() || !rpc)
  {
    return;
  }

  rpc.log(getLocationString());

  const eventListener = (event) =>
  {
    rpc.log(getLocationString());
  }

  window.addEventListener('hashchange', eventListener);

  return () =>
  {
    window.removeEventListener('hashchange', eventListener);
  }
});
